import { Box, Icon, IconButton, StyledEngineProvider } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import withStyles from '@mui/styles/withStyles'
import { authRoles, hasRole } from 'app/auth/authRoles'
import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import SidenavTheme from '../EgretTheme/SidenavTheme'
import Brand from '../SharedCompoents/Brand'
import Sidenav from '../SharedCompoents/Sidenav'
import { OrganisationPanel } from './OrganisationPanel'

export const IconButtonWhite = withStyles(theme => {
  return {
    root: {
      color: theme?.sidebar?.sidebarIconsColor,
      backgroundColor: 'transparent',
      padding: '5px'
    }
  }
})(IconButton)

export const IconSmall = withStyles(() => ({
  root: {
    fontSize: '1rem'
  }
}))(Icon)

const Layout1Sidenav = ({ theme, layoutSidenavRef, contentWrapRef, isToggleBtnTouchedRef, mode }) => {
  const user = useSelector(state => state.user)
  const organization = useSelector(state => state.organization)
  const settings = useSelector(state => state.layout.settings)

  const sidenavRef = useRef(null)
  const sidenavHoldRef = useRef(null)

  // const {
  //   updateElementStyles,
  //   getZoomFactor,
  //   initialStylesRef,
  // } = useSidebarDimensions()

  const hidden = mode === 'hidden'
  const isCollapsed = mode === 'close'
  const isFull = mode === 'full'
  const isFullRef = useRef(isFull)

  useEffect(() => {
    isFullRef.current = isFull
  }, [isFull])

  // function to update zoom factor for ripple elements
  const updateRippleElements = ({ zoomFactor }) => {
    const rippleElements = document.querySelectorAll('.MuiTouchRipple-root')
    Array.from(rippleElements).forEach((element) => {
      element.style.height = '100%'
      element.style.width = '100%'
    })
  }

  // const handleResize = (event) => {
  //   if (layoutSidenavRef.current){
  //     const isResize = event !== undefined
  //     const zoomFactor = getZoomFactor()
  //     if(contentWrapRef.current) {
  //       contentWrapRef.current.style.borderLeftWidth = `${zoomFactor}px`;
  //     }
  //     updateElementStyles({
  //       element: layoutSidenavRef.current,
  //       mode,
  //       isResize,
  //       isToggleBtnTouched: isToggleBtnTouchedRef.current,
  //       updateElementStylesCallback: (zoomFactor) => {
  //         setTimeout(() => {
  //           updateRippleElements({zoomFactor})
  //         }, 100)
  //       }
  //     })
  //   }
  // }

  // useEffect(() => {
  //   handleResize()
  //   window.addEventListener('resize', handleResize)
  //   return () => {
  //     window.removeEventListener('resize', handleResize)
  //   }
  // }, [mode])

  useEffect(() => {
    const getZoomFactor = () => 1 // () => 1 / window.devicePixelRatio
    if (layoutSidenavRef.current && sidenavRef.current && isCollapsed) {
      sidenavRef.current.style.transitionDuration = '0.3s'
      setTimeout(() => {
        sidenavRef.current.style.width = `${301 * getZoomFactor()}px`
        layoutSidenavRef.current.style.width = '0px'
        layoutSidenavRef.current.style.transform = `translateX(-${301 * getZoomFactor()}px)`
      }, 0)
    } else if (layoutSidenavRef.current && sidenavRef.current && !isCollapsed) {
      sidenavRef.current.style.transitionDuration = '0.3s'
      setTimeout(() => {
        layoutSidenavRef.current.style.width = `${301 * getZoomFactor()}px`
        sidenavRef.current.style.width = `${301 * getZoomFactor()}px`
        layoutSidenavRef.current.style.transform = 'translateX(0px)'
      }, 0)
    }
    setTimeout(() => {
      layoutSidenavRef.current.style.transitionDuration = '0s'
      sidenavRef.current.style.transitionDuration = '0s'
    }, 100)
  }, [isCollapsed, layoutSidenavRef, sidenavRef])

  const sidenavTheme =
    settings.themes[
      settings.sidebarThemes[settings.activeTheme].leftSidebar.theme
    ] || theme

  if (hidden) return null

  return (
    <Box
      ref={layoutSidenavRef}
      className='layout1-sidenav'
      sx={{
        zIndex: 1000,
        transformOrigin: 'top left',
        position: 'relative'
      }}
    >
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={sidenavTheme}>
          <SidenavTheme theme={sidenavTheme} settings={settings} />
          <div
            className='sidenav'
            ref={sidenavRef}
            style={{
              position: 'relative',
              left: 0,
              top: 0,
              height: '100%',
              overflow: 'visible'
            }}
          >
            <div
              className='sidenav__hold'
              ref={sidenavHoldRef}
              data-tut='sidenav'
              style={{
                backgroundSize: '150px'
              }}
            >
              <>
                {hasRole(user.role, authRoles.tester) &&
                  <div style={{ paddingLeft: 4, paddingTop: 4 }}>
                    {process.env.REACT_APP_VERSION}
                  </div>}
                <Brand />
                <Sidenav>
                  <OrganisationPanel
                    user={user}
                    organization={organization}
                    settings={settings}
                  />
                </Sidenav>
              </>
            </div>
          </div>
        </ThemeProvider>
      </StyledEngineProvider>
    </Box>
  )
}

export default Layout1Sidenav
